/**************************
 * @author: FengYan
 * @update: 20170523
 * @description:供应商顶部工具栏
 *************************/
/************  基础组件  *************/
import React, {Component} from 'react';
// import './styles/styles.css';
import './styles/style.less';
import {Row, Col, Icon, Button, Modal, Dropdown, Menu} from 'jcloudui';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import getCitys, {getCitysAction} from './redux/citys_redux';
import isLogin, {getLoginAction} from './redux/isLogin_redux';
import getUrl, {getUrlAction} from './redux/getUrl_redux';
import getCode, {getCodeAction} from './redux/getCode_redux';
import getTel, {getTelAction} from './redux/getTel_redux';
import onLogout from '../../sso/onLogout';
import ApiClient from '../../apiClient/ApiClient';
const client = new ApiClient();

/************  自定义组件  *************/
@connect(
  state => (getCitys, isLogin, getUrl, getCode, getTel),
  dispatch => bindActionCreators({getCitysAction, getLoginAction, getUrlAction, getCodeAction, getTelAction}, dispatch)
)

export default class TopTools extends Component {
  constructor(props) {
    super(props);
    this.state = {
      citys: [],
      citysVisible: false,
      cityName: '',
      cityId: '',
      username: '',
      shopDomain: '',
      buyerDomain: '',
      paltformDomain: '',
      domain: '',
      contactInfo: '',
      weixinCodeUrl: '',
      appDownCodeUrl: '',
      shopNum: 0
    };
  }

  setCookie({areaId, areaName}) {
    // 存储，IE6~7 cookie 其他浏览器HTML5本地存储
    const cityName = encodeURIComponent(areaName);
    document.cookie = `areaName=${cityName}; path=/; domain=${this.state.domain}`;
    document.cookie = `areaId=${areaId}; path=/; domain=${this.state.domain}`;
    // if (localStorage) {
    //   localStorage.areaId = areaId;
    //   localStorage.areaName = areaName;
    this.defaultCookie();
    // this.setState({
    //   cityName: areaName,
    //   cityId: areaId
    // });
    // } else {
    // document.cookie = `areaId=${areaId};areaName=${areaName}`;
    // }
    if (this.state.citysVisible) {
      this.setState({
        citysVisible: false
      });
    }
    document.getElementById('citys').style.display = 'none';
  }

  renderCity(citys) {
    // 一级地市列表渲染
    const cityArr = [];
    citys.map(_city => {
      cityArr.push(
        <li key={_city.code + Math.random()}>
          <a
            href="javascript:void(0)"
            onClick={() => this.setCookie({areaId: _city.code, areaName: _city.name})}
            className={this.state.cityName === _city.name ? 'active' : ''}
            key={_city.code}
            title={_city.name}
          >
            {_city.name.length > 5 ? `${_city.name.substr(0, 5)}...` : _city.name}
          </a>
        </li>);
    });
    return cityArr;
  }

  componentWillMount() {
    // 获取一级地市数据，存入citys
    this.props.getCitysAction().then(rs => {
      if (rs.code != 0) return;
      let cityList = [];
      rs.data.map(_item => {
        cityList.push({
          name: _item.name,
          code: _item.code
        });
      });
      this.setState({
        citys: cityList
      });
      this.defaultCookie();
    });
    // 获取用户登录信息
    this.props.getLoginAction().then(rs => {
      this.setState({
        username: rs.data.username
      });
    });
    // 获取url
    this.props.getUrlAction().then(rs => {
      if (rs.code == 0) {
        rs.data.map(_item => {
          if (_item.domainType == 3) this.setState({shopDomain: _item.domain});
          if (_item.domainType == 2) this.setState({buyerDomain: _item.domain});
          if (_item.domainType == 5) this.setState({paltformDomain: _item.domain});
          if (_item.domainType == 1) this.setState({domain: _item.domain});
        });
      }
    });

    // 获取二维码
    this.props.getCodeAction().then(rs => {
      if (rs.code == 0) {
        this.setState({
          weixinCodeUrl: rs.data.weixinCodeUrl,
          appDownCodeUrl: rs.data.appDownCodeUrl
        });
      }
    });
    // 获取 400电话
    this.props.getTelAction().then(rs => {
      if (rs.code == 0) {
        this.setState({
          contactInfo: rs.data[0].contactInfo
        });
      }
    });
    // 获取购物车数量
    client.get('cart/mall/cart/queryCartItemNum').then(rs => {
      if (rs.code == 0) {
        this.setState({
          shopNum: rs.data
        });
      }
    });
  }

  componentDidMount() {
    document.getElementById('chooseLocal').onmouseenter = () => {
      document.getElementById('citys').style.display = 'inline-block';
    };
    document.getElementById('chooseLocal').onmouseleave = () => {
      document.getElementById('citys').style.display = 'none';
    };
  }

  defaultCookie() {
    const cookie = document.cookie;
    const cookieArr = cookie.split(';');
    if (cookie.indexOf('areaId') < 0) {
      this.setState({
        citysVisible: true
      });
    } else {
      cookieArr.map(_item => {
        if (_item.indexOf('areaName') >= 0) {
          this.setState({
            cityName: decodeURIComponent(_item.substr(_item.indexOf('=') + 1, _item.length))
          });
        } else {
          this.setState({
            cityId: _item.substr(_item.indexOf('=') + 1, _item.length)
          });
        }
      });
    }
    // }
  }

  logout() {
    const logouts = {
      "passport": ["/service-passport-view/logout", false],
      "shop": ["/shop-view/logout", false],
      "buyer": ["/buyer-view/logout", false],
      "main": ["/website-view/logout", false]
    }
    onLogout(logouts, "login");
  }

  /*
   * 判断是否显示店铺列表或者公司列表
   * */
  isBuyer() {
    if (typeof window === 'undefined') return;
    const urlPath = window.location.href;
    if (urlPath.indexOf('buyer.') !== -1) {
      return true;
    }
    return false;
  }

  strSize(text) {
    let str = '';
    let num = 0;
    const reg = /[\x00-\xff]/;
    for (let i in text) {

      if (!reg.test(text[i])) {
        num += 2;
      } else {
        num += 1;
      }
      if (num <= 4) {
        str += text[i];
      } else {
        str += '...';
        break;
      }
    }
    return str;
  }

  render() {
    return (
      <Row className="topTools">
        <Modal
          visible={this.state.citysVisible}
          title="请选择你的收货地区"
          footer={null}
          closable={false}
        >
          <div className="unChooseLocal">
            <ul>
              {this.renderCity(this.state.citys)}
            </ul>
          </div>
        </Modal>
        <Row className="topToolsWidth">
          <Col span={7}>
            <div className="toolsLocal">
              <ul>
                {/* 归属地 */}
                <li className="f-fl mr20">
                  <div className="downMenu chooseLocal" id="chooseLocal">
                    <a href="javascript:void(0)" className="normal-a">
                      <Icon
                        type="new-gps"
                        className="textColorUnRed top5 font30"
                      />
                      {this.state.cityName.length > 3 ? `${this.state.cityName.substr(0, 3)}...` : this.state.cityName}
                    </a>
                    <ul id="citys">
                      {this.renderCity(this.state.citys)}
                    </ul>
                  </div>
                </li>
                <li>
                  欢迎来到华南城网工业品MRO商城!
                </li>
              </ul>
            </div>
          </Col>
          <Col span={17}>
            <div className="toolsMenu">
              <ul>
                {/* 登录信息 */}
                {
                  this.state.username ?
                    (<li>
                     <span>
                       <a href={`//${this.state.buyerDomain}/buyer-view/homepage`}
                          className="textColorUnRed" title={this.state.username}>{this.strSize(this.state.username)}</a>
                       <a href="javascript:void(0)" onClick={() => this.logout()}>[退出]</a>
                     </span>
                    </li>) :
                    (<li>
                      {/* <a href={`//${this.state.buyerDomain}/service-passport-view/login`}>请登录</a> */}
                      {/* <a href={`//${this.state.buyerDomain}/service-passport-view/register`}>免费注册</a> */}
                    </li>)
                }

                {/* 我的订单 */}
                <li>
                  <a href={`//${this.state.buyerDomain}/order-buyer-view/purchaserback/ordermanagement`}>我的订单</a>
                </li>
                {/* 我的商城 */}
                <li>
                  <div className="downMenu my-mall">
                    <a> 我的商城 <Icon type="down ml5"/> </a>
                    <ul>
                      <li>
                        <p>
                          <a href={`//${this.state.buyerDomain}/order-buyer-view/quotation-manage/quotation-list`}
                             target="_blank"> 报价单管理 </a>
                        </p>
                        <p>
                          <a href={`//${this.state.buyerDomain}/order-buyer-view/purchasedlist`}
                             target="_blank"> 已购商品列表 </a>
                        </p>
                        <p>
                          <a href={`//${this.state.buyerDomain}/customer-service-buyer-view/refund/grid`}
                             target="_blank"> 退款/售后管理 </a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <a href={`//${this.state.buyerDomain}/buyer-view/attention-center/collection`}
                             target="_blank">我的收藏</a></p>
                        <p>
                          <a href={`//${this.state.buyerDomain}/member-buyer-view/memberintegral`}
                             target="_blank">我的积分</a></p>
                        <p>
                          <a href={`//${this.state.buyerDomain}/promotion-buyer-view/coupon/grid`}
                             target="_blank">我的优惠券</a>
                        </p>
                        <p>
                          <a href={`//${this.state.buyerDomain}/promotion-buyer-view/recommend`}
                             target="_blank">有奖推荐</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>
                {/* 二维码 */}
                <li>
                  <div className="downMenu app">
                    <a className="normal-a">
                      <Icon type="new-phone iconSize"/>
                    </a>
                    <ul>
                      <span className="app-up"></span>
                      <li>
                        <img src={this.state.weixinCodeUrl} alt="微信商城"/>
                        <p>微信扫一扫</p>
                        <p>关注华南城网</p>
                        <p>微信商城</p>
                      </li>
                      <li>
                        <img src={this.state.appDownCodeUrl} alt="立即下载APP"/>
                        <p>扫描二维码</p>
                        <p>立即下载APP</p>
                      </li>
                    </ul>
                  </div>
                </li>
                {/* 购物车 */}
                <li>
                  <a href={`//${this.state.domain}/website-view/cart`} className="normal-a">
                    <Icon type="new-cart" className="cart-size"/>
                    <span className={this.state.shopNum < 1 ? 'f-dn' : 'icon-num'}>
                      {this.state.shopNum > '99' ? '99+' : this.state.shopNum}
                      </span>
                  </a>
                </li>
                {/* 消息中心 */}
                <li>
                  {
                    this.isBuyer() ?
                      <a href={`//${this.state.buyerDomain}/buyer-view/message/message-center`}>消息</a> :
                      <a href={`//${this.state.shopDomain}/shop-view/message/message-center`}>消息</a>
                  }
                </li>
                {/* 供应商中心 */}
                <li>
                  <a href={`//${this.state.shopDomain}/shop-view/home`}>供应商中心</a>
                </li>
                {/* 在线客服 */}
                <li className="tel-phone">
                  <a href="javascript:void(0)">
                    <Icon
                      type="new-phone2"
                      className="textColorRed marginRight5 tel-phone-icon"
                    />
                    <strong className="hotLine">{this.state.contactInfo}</strong>
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Row>
    )
      ;
  }
}